<div class="row">
	<create-contest-navbar class="col-sm-3 col-md-2"></create-contest-navbar>
	<div class="col-sm-9 col-md-offset-1 col-md-8">
		<router-outlet></router-outlet>
	</div>
</div>